import { NewDynamicTab } from "../../../components/Page";
import { getLast30DaysDateRange, getLast7DaysDateRange } from "../../Rajasthan/Utility/const";
import PriceIndex from "./PriceIndex";
import PriceIndexAdvanced from "./PriceIndexAdvanced";

const PriceIndexWrapper = () => {
  return (
    <NewDynamicTab
      header="Price Index"
      tabs={{
        "Price Index Advanced": <PriceIndexAdvanced />,
      }}
      defaultDates={{
        "Price Index Advanced": {
          type: "range",
          defaultRangeDate: getLast30DaysDateRange(),
        },
      }}
    />
  );
};

export default PriceIndexWrapper;
